import { estimateurEtapeMock, titreDescriptionMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [estimateurEtapeMock, titreDescriptionMock(true, false, 'h2', 'center')];

export const estimateurBudgetStep1Mock: SlugPage = {
  ...pageBase({
    title: 'Estimateur de bugdet - Etape 1',
    type: 'estimateur-budget',
    language: 'fr-FR',
    headerId: 'tunnel-estimateur-fr',
    footerId: '',
    isBreadcrumbOverlay: true,
  }),
  blocks,
};
